import angular from 'angular';
import moment from 'moment';
import gridHeight from '../core/shared-service/grid-utils';

class buyerRelationsCtrl {
    /* @ngInject */
    constructor(
        logger,
        $translate,
        uiGridExporterConstants,
        $uibModal,
        PRINCIPAL,
        invitedEntitySvc,
        PrincipalSvc,
        InvBuyerRelationFilter,
        $window
    ) {
        this.logger = logger;
        this.$translate = $translate;
        this.uiGridExporterConstants = uiGridExporterConstants;
        this.$uibModal = $uibModal;
        this.PRINCIPAL = PRINCIPAL;
        this.invitedEntitySvc = invitedEntitySvc;
        this.PrincipalSvc = PrincipalSvc;
        this.InvBuyerRelationFilter = InvBuyerRelationFilter;
        this.$window = $window;
    }

    $onInit() {
        var defaultCellTemplate = '<div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div>';
        // ---------------
        // Data API
        // ---------------
        // Recherche
        this.buyer = this.invBuyerBo.invitedEntity;
        this.invBuyServices = this.PRINCIPAL.invBuyServices;
        this.searchOpen = true;
        this.searchData = new this.InvBuyerRelationFilter();
        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'sellerPrincipalCorporateName',
                    displayName: 'invited_entity_relation.list.do',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    exporterSuppressExport: (!this.principalInfo) ? false : true,
                    sort: { direction: 'asc', priority: 0 },

                },
                {
                    name: 'seller.getCountryLabel()',
                    displayName: 'invited_entity_relation.list.country',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    sort: { direction: 'asc', priority: 1 },

                },
                {
                    name: 'seller.getIdentifiant()',
                    displayName: 'invited_entity_relation.list.buyer_id',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'seller.name',
                    displayName: 'invited_entity_relation.list.buyer_name',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    sort: { direction: 'asc', priority:2 },

                },
                {
                    name: 'getEnabledServices()',
                    displayName: 'invited_entity_relation.list.portal_service',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'creationDate',
                    displayName: 'invited_entity_relation.list.creation_relation',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'acceptation',
                    displayName: 'invited_entity_relation.list.acceptation',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
                {
                    name: 'endOfValidity',
                    displayName: 'invited_entity_relation.list.validity',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                },
            ],
            exporterOlderExcelCompatibility: true,
            onRegisterApi: gridApi => (this.gridApi = gridApi),
            enableSorting: true,
            enableGridMenu: false,
            data: this.relations,
            enableColumnMenus: false,
        };
        this.gridOptions.columnDefs[0].visible = !this.principalInfo;
    }
    searchPrincipals(value) {
        if (value && value.length >= 3) {
            return this.PrincipalSvc.searchPrincipals(value).then(principals => {
                return principals;
            });
        }
    }

    searchCompanies(value) {
        if (value && value.length >= 3) {
            return this.PrincipalSvc.searchCompanies(value).then(companies => {
                return companies;
            });
        }
    }

    search() {
        if(this.PrincipalSvc.getPrincipal()  && this.principalInfo && this.principalInfo.corporateName){
            this.searchData.principal = this.PrincipalSvc.getPrincipal().detail;
        }
        this.invitedEntitySvc.searchInvBuyerRelations(this.buyer.legalEntity.id, this.searchData).then(
            relations => {
                this.gridOptions.data = relations;
            },
            (/*error*/) => {
                this.logger.error('error.search');
            }
        );
    }

    clearForm() {
        // Reset data
        this.searchData = new this.InvBuyerRelationFilter();
        // Reset form
        this.form.$setPristine();
        // Recherche
        this.search();
    }

    exportCsv() {
        this.gridOptions.exporterCsvFilename = 'relations-client_' + moment().format('DDMMYYYY') + '.csv';
        this.gridOptions.exporterHeaderFilter = this.$translate.instant;
        this.gridOptions.exporterSuppressColumns = ['detail'];
        this.gridApi.exporter.csvExport(this.uiGridExporterConstants.ALL, this.uiGridExporterConstants.ALL);
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    back() {
        this.$window.history.back();
    }
}

angular.module('app.principal').component('invBuyerRelations', {
    templateUrl: require('./invited-buyer-relations.html'),
    controller: buyerRelationsCtrl,
    bindings: {
        invBuyerBo: '<',
        relations: '<',
        principalInfo: '<',
    },
});
